import { useState } from "react";
import AccordionDetails from "./AccordionDetails";
import AccordionSummary from "./AccordionSummary";

export default function Accordion({
  accordionItem,
  icons,
  summaryContent,
  expandedContent,
  index,
  totalExpandedAccordions = {
    expandedAccordions: [],
    setExpandedAccordions: () => {},
  },
  expandOnIconClickOnly,
}) {
  const { expandedAccordions, setExpandedAccordions } = totalExpandedAccordions;

  const [expandAccordion, setExpandAccordion] = useState(
    expandedAccordions.includes(index),
  );

  const storeAccordionStatus = () => {
    setExpandedAccordions((prev) => {
      if (prev.includes(index)) {
        return prev.filter((item) => item !== index);
      }
      return [...prev, index];
    });
  };

  return (
    <div>
      <AccordionSummary
        accordionItem={accordionItem}
        expandAccordion={expandAccordion}
        setExpandAccordion={setExpandAccordion}
        icons={icons}
        summaryContent={summaryContent}
        storeAccordionStatus={storeAccordionStatus}
        expandOnIconClickOnly = {expandOnIconClickOnly}
      >
        <AccordionDetails
          accordionItem={accordionItem}
          isOpen={expandAccordion}
        >
          {expandedContent}
        </AccordionDetails>
      </AccordionSummary>
    </div>
  );
}
